import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';
const API = `${BACKEND_URL}/api`;

/** Endpoints where a 401 is an answer ("wrong password"), not an expired session. */
const AUTH_ENDPOINTS = ["/auth/login", "/auth/register", "/auth/forgot-password", "/auth/reset-password"];
const isAuthAttempt = (endpoint) => AUTH_ENDPOINTS.some((a) => endpoint.startsWith(a));

const api = async (method, endpoint, data = null, token = null) => {
  const config = {
    method,
    url: `${API}${endpoint}`,
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  };
  if (data) config.data = data;
  try {
    return await axios(config);
  } catch (err) {
    // A 401 normally means "your session expired" — drop the stored token and send
    // the user back to the login screen.
    //
    // Except on the auth endpoints themselves, where a 401 means "wrong password".
    // Redirecting there reloaded the page mid-submit, which wiped the React tree and
    // destroyed the toast before it could render: a wrong password produced a blank
    // screen and no message at all, rather than "Invalid credentials".
    if (err.response?.status === 401 && !isAuthAttempt(endpoint)) {
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      window.location.href = "/";
    }
    throw err;
  }
};

/**
 * Zapytanie, które nie może zgasić całego ekranu.
 *
 * Oba pulpity ładują dane jednym `Promise.all` — trenerski ma tam 29 wywołań.
 * Przy `Promise.all` pierwszy odrzucony obiecuje wysadza całą tablicę, więc
 * jeden błąd 500 w dowolnym z nich zostawiał puste okno zamiast brakującej
 * sekcji. Zdarzyło się to naprawdę: `/ratings/my` wywracał się na `round(None)`
 * i gasił cały pulpit trenera.
 *
 * `soft` zamienia odrzucenie na wartość zastępczą i **głośno loguje**, żeby
 * awaria nie stała się niewidzialna.
 */
const soft = (promise, fallback = null, label = "") =>
  promise.catch((err) => {
    console.warn(`[duofit] nie udało się pobrać ${label || "danych"}:`, err?.response?.status || err);
    return { data: fallback };
  });

export { api, soft, BACKEND_URL, API };
